import {isValidPhoneNumber} from 'react-phone-number-input';
import {FORM_STEP_KEY, NO_REGISTER} from './FormStep';
import {EMAIL} from './Pattern';
import Home from '../component/step/home';
import Submit from '../component/step/submit';
import PhoneNumberInput from '../component/common/phone-number-input';
import Checkbox from '../component/common/checkbox';
import Select from '../component/common/select';
import TextArea from '../component/common/text-area';
import AnalyticsService from '../service/AnalyticsService';


const FORM_CONFIGURATION = {
  [FORM_STEP_KEY.HOME] : {
    components : [{
      key       : `${FORM_STEP_KEY.HOME}-component-1`,
      component : Home,
      metadata  : {
        name       : NO_REGISTER,
        validation : []
      }
    }],
    formStepProps : {
      isCentered : true,
      hooks      : {
        onGoNext : (step, stepValues, formValues) => {
          AnalyticsService.trackFormStep(step);
        }
      }
    }
  },
  [FORM_STEP_KEY.TYPE_OF_SERVICES] : {
    components : [{
      key       : `${FORM_STEP_KEY.TYPE_OF_SERVICES}-component-1`,
      component : Select,
      metadata  : {
        name       : 'typeOfServices',
        validation : [{
          isRequired   : true,
          validationFn : value => {
            const isValid = Array.isArray(value) && value.length > 0;

            if (!isValid) {
              return ['Please select at least one type of service'];
            }

            return null;
          }
        }]
      },
      props : {
        defaultValue : [],
        label        : 'What type of service are you interested in? *',
        options      : [{
          hotKey : 'a',
          label  : 'Measurement & Forecasting',
          value  : 'Measurement & Forecasting'
        }, {
          hotKey : 'b',
          label  : 'MLOps & ML Engineering',
          value  : 'MLOps & ML Engineering'
        }, {
          hotKey : 'c',
          label  : 'DataOps & Lakehouse Engineering',
          value  : 'DataOps & Lakehouse Engineering'
        }, {
          hotKey : 'd',
          label  : 'Data Science & GenAI',
          value  : 'Data Science & GenAI'
        }, {
          hotKey : 'e',
          label  : 'ML Platform & Infrastructure-as-Code',
          value  : 'ML Platform & Infrastructure-as-Code'
        }],
        mode : Select.MODE.MULTIPLE_CHOICE
      }
    }],
    formStepProps : {
      isCentered : false,
      hooks      : {
        onGoNext : (step, stepValues, formValues) => {
          AnalyticsService.trackFormStep(step);
        }
      }
    }
  },
  [FORM_STEP_KEY.AREA_OF_EXPERTISE] : {
    components : [{
      key       : `${FORM_STEP_KEY.AREA_OF_EXPERTISE}-component-1`,
      component : Select,
      metadata  : {
        name       : 'areaOfExpertise',
        validation : [{
          isRequired   : true,
          validationFn : value => {
            const isValid = Array.isArray(value) && value.length > 0;

            if (!isValid) {
              return ['Please select at least one area of expertise'];
            }

            return null;
          }
        }]
      },
      props : {
        defaultValue : [],
        label        : 'Which area do you need help with? *',
        options      : [{
          hotKey : 'a',
          label  : 'Redemption & Claims Forecasting',
          value  : 'Redemption & Claims Forecasting'
        }, {
          hotKey : 'b',
          label  : 'Incrementality & Holdout Measurement',
          value  : 'Incrementality & Holdout Measurement'
        }, {
          hotKey : 'c',
          label  : 'Breakage & Reserve Estimation',
          value  : 'Breakage & Reserve Estimation'
        }, {
          hotKey : 'd',
          label  : 'Churn & Lapse Prediction',
          value  : 'Churn & Lapse Prediction'
        }, {
          hotKey : 'e',
          label  : 'Data Pipelines & Lakehouse',
          value  : 'Data Pipelines & Lakehouse'
        }, {
          hotKey : 'f',
          label  : 'MLOps & Production ML',
          value  : 'MLOps & Production ML'
        }, {
          hotKey : 'g',
          label  : 'ML Platform & Cloud Infrastructure',
          value  : 'ML Platform & Cloud Infrastructure'
        }, {
          hotKey : 'h',
          label  : 'Data Science & GenAI',
          value  : 'Data Science & GenAI'
        }, {
          hotKey : 'i',
          label  : 'Other',
          value  : 'Other'
        }],
        mode : Select.MODE.MULTIPLE_CHOICE
      }
    }],
    formStepProps : {
      isCentered : false,
      hooks      : {
        onGoNext : (step, stepValues, formValues) => {
          AnalyticsService.trackFormStep(step);
        }
      }
    }
  },
  [FORM_STEP_KEY.COLLABORATION_TYPE] : {
    components : [{
      key       : `${FORM_STEP_KEY.COLLABORATION_TYPE}-component-1`,
      component : Select,
      metadata  : {
        name       : 'collaborationType',
        validation : [{
          isRequired   : true,
          validationFn : value => {
            const isValid = Boolean(value);

            if (!isValid) {
              return ['Please select one option'];
            }

            return null;
          }
        }]
      },
      props : {
        defaultValue : null,
        label        : 'How would you prefer to collaborate? *',
        options      : [{
          hotKey : 'a',
          label  : 'Fixed Price',
          value  : 'Fixed Price'
        }, {
          hotKey : 'b',
          label  : 'Time And Materials',
          value  : 'Time And Materials'
        }, {
          hotKey : 'c',
          label  : 'Dedicated Team',
          value  : 'Dedicated Team'
        }, {
          hotKey : 'd',
          label  : 'Other',
          value  : 'Other'
        }]
      }
    }],
    formStepProps : {
      isCentered : false,
      hooks      : {
        onGoNext : (step, stepValues, formValues) => {
          AnalyticsService.trackFormStep(step);
        }
      }
    }
  },
  [FORM_STEP_KEY.NUMBER_OF_ENGINEERS_NEEDED] : {
    components : [{
      key       : `${FORM_STEP_KEY.NUMBER_OF_ENGINEERS_NEEDED}-component-1`,
      component : Select,
      metadata  : {
        name                : 'numberOfEngineers',
        navigateOnSelection : false,
        validation          : [{
          isRequired   : true,
          validationFn : value => {
            const isValid = Boolean(value);

            if (!isValid) {
              return ['Please select one option'];
            }

            return null;
          }
        }]
      },
      props : {
        defaultValue : null,
        label        : 'How many people would you want on the team? *',
        options      : [{
          hotKey : 'a',
          label  : '1',
          value  : 1
        }, {
          hotKey : 'b',
          label  : '2',
          value  : 2
        }, {
          hotKey : 'c',
          label  : '3',
          value  : 3
        }, {
          hotKey : 'd',
          label  : '5',
          value  : 5
        }, {
          hotKey : 'e',
          label  : 'More',
          value  : 'More'
        }, {
          hotKey : 'f',
          label  : 'I don\'t know',
          value  : 'I dont know'
        }]
      }
    }],
    formStepProps : {
      isCentered : false,
      hooks      : {
        onGoNext : (step, stepValues, formValues) => {
          AnalyticsService.trackFormStep(step);
        }
      }
    }
  },
  [FORM_STEP_KEY.CUSTOMER_NAME] : {
    components : [{
      key       : `${FORM_STEP_KEY.CUSTOMER_NAME}-component-1`,
      component : TextArea,
      metadata  : {
        name       : 'customerName',
        validation : [{
          isRequired   : true,
          validationFn : value => {
            const isValid = Boolean(value);

            if (!isValid) {
              return ['Please type your name'];
            }

            return null;
          }
        }]
      },
      props : {
        autoFocus   : true,
        autoSize    : true,
        hint        : '<strong>Shift ⇧</strong> + <strong>Enter ↵</strong> to make a line break',
        label       : 'What is your name? *',
        placeholder : 'Type your answer here...'
      }
    }],
    formStepProps : {
      isCentered : false,
      hooks: {
        onGoNext : (step, stepValues, formValues) => {
          AnalyticsService.trackFormStep(step);
        }
      }
    }
  },
  [FORM_STEP_KEY.CUSTOMER_COMPANY_NAME] : {
    components : [{
      key       : `${FORM_STEP_KEY.CUSTOMER_COMPANY_NAME}-component-1`,
      component : TextArea,
      metadata  : {
        name       : 'customerCompanyName',
        validation : [{
          isRequired   : true,
          validationFn : value => {
            const isValid = Boolean(value);

            if (!isValid) {
              return ['Please type your name'];
            }

            return null;
          }
        }]
      },
      props : {
        autoFocus   : true,
        autoSize    : true,
        hint        : '<strong>Shift ⇧</strong> + <strong>Enter ↵</strong> to make a line break',
        label       : 'What is your company name? *',
        placeholder : 'Type your answer here...'
      }
    }],
    formStepProps : {
      isCentered : false,
      hooks: {
        onGoNext : (step, stepValues, formValues) => {
          AnalyticsService.trackFormStep(step);
        }
      }
    }
  },
  [FORM_STEP_KEY.CUSTOMER_EMAIL_ADDRESS] : {
    components : [{
      key       : `${FORM_STEP_KEY.CUSTOMER_EMAIL_ADDRESS}-component-1`,
      component : TextArea,
      metadata  : {
        name       : 'customerEmailAddress',
        validation : [{
          isRequired   : true,
          validationFn : value => {
            const isValid = typeof value === 'string' && value.length > 0;

            if (!isValid) {
              return ['Please type your email address'];
            }

            return null;
          }
        }, {
          isRequired : true,
          validationFn : value => {
            const isValid = EMAIL.test(value);

            if (!isValid) {
              return ['Hmm...that email doesn\'t look valid'];
            }

            return null;
          }
        }]
      },
      props : {
        autoFocus   : true,
        autoSize    : true,
        label       : 'Give us an email address to get back to you *',
        placeholder : 'Type your email here...'
      }
    }],
    formStepProps : {
      isCentered : false,
      hooks: {
        onGoNext : (step, stepValues, formValues) => {
          AnalyticsService.trackFormStep(step);
        }
      }
    }
  },
  [FORM_STEP_KEY.CUSTOMER_EXTRA_INFORMATION] : {
    components : [{
      key       : `${FORM_STEP_KEY.CUSTOMER_EXTRA_INFORMATION}-component-1`,
      component : TextArea,
      metadata  : {
        name       : 'customerExtraInformation',
        validation : [{
          isRequired   : true,
          validationFn : () => null
        }]
      },
      props : {
        autoFocus   : true,
        autoSize    : true,
        hint        : '<strong>Shift ⇧</strong> + <strong>Enter ↵</strong> to make a line break',
        label       : 'Do you have any other information you would like to share with us?',
        placeholder : 'Type your answer here...'
      }
    }],
    formStepProps : {
      isCentered : false,
      hooks: {
        onGoNext : (step, stepValues, formValues) => {
          AnalyticsService.trackFormStep(step);
        }
      }
    }
  },
  [FORM_STEP_KEY.CUSTOMER_PHONE_NUMBER] : {
    components : [{
      key       : `${FORM_STEP_KEY.CUSTOMER_PHONE_NUMBER}-component-1`,
      component : PhoneNumberInput,
      metadata  : {
        name       : 'customerPhoneNumber',
        validation : [{
          isRequired   : true,
          validationFn : value => {
            const isValid = Boolean(value);

            if (!isValid) {
              return ['Please type your phone number'];
            }

            return null;
          }
        }, {
          isRequired   : true,
          validationFn : value => {
            const isValid = isValidPhoneNumber(value);

            if (!isValid) {
              return ['Phone number is invalid'];
            }

            return null;
          }
        }]
      },
      props : {
        autoFocus   : true,
        label       : 'If you want us to call you back please leave your number',
        placeholder : undefined
      }
    }],
    formStepProps : {
      isCentered     : false,
      showSkipButton : true,
      hooks          : {
        onGoNext : (step, stepValues, formValues) => {
          AnalyticsService.trackFormStep(step);
        }
      }
    }
  },
  [FORM_STEP_KEY.GDPR_CONSENT] : {
    components : [{
      key       : `${FORM_STEP_KEY.GDPR_CONSENT}-component-1`,
      component : Checkbox,
      metadata  : {
        name       : 'gdprConsent',
        validation : [{
          isRequired   : true,
          validationFn : value => {
            const isValid = Boolean(value);

            if (!isValid) {
              return ['You must give consent'];
            }

            return null;
          }
        }]
      },
      props : {
        defaultValue : false,
        label        : 'GDPR consent *',
        description  : 'I give my consent for Qwertee Technology to use this information to contact me'
      }
    }],
    formStepProps : {
      isCentered : false,
      hooks      : {
        onGoNext : (step, stepValues, formValues) => {
          AnalyticsService.trackFormStep(step);
        }
      }
    }
  },
  [FORM_STEP_KEY.SUBMIT] : {
    components : [{
      key       : `${FORM_STEP_KEY.SUBMIT}-component-1`,
      component : Submit,
      metadata  : {
        name       : NO_REGISTER,
        validation : []
      }
    }],
    formStepProps : {
      isCentered             : true,
      showNavigationControls : false,
      hooks: {
        onGoNext : (step, stepValues, formValues) => {
          AnalyticsService.trackFormStep(step);
        }
      }
    }
  }
};

export {
  FORM_CONFIGURATION
};
